var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"orderDetail"},[_c('topHead',[_c('h3',{attrs:{"slot":"header"},slot:"header"},[_vm._v("订单详情")])]),_c('div',{staticClass:"main"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }